import { usePermissions, useTranslate } from "@refinedev/core";
import { SettingsTileCard, SwapIcon } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Pairing epic D: the organisation's connection with the Fawkes platform (foster families, absences,
// aftercare, DierMatch). Opens the pairing/test screen. Only for holders of
// ROLE_PLATFORM_CONNECTION_ADMIN — everyone else does not see the tile at all.
export const PLATFORM_CONNECTION_TILE_KEY = "platform-connection";
export const PLATFORM_CONNECTION_ADMIN = "ROLE_PLATFORM_CONNECTION_ADMIN";

export function PlatformConnectionTile({ onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  const { data: permissions } = usePermissions<string[]>();
  if (!Array.isArray(permissions) || !permissions.includes(PLATFORM_CONNECTION_ADMIN)) {
    return null;
  }
  return (
    <SettingsTileCard
      tileKey={PLATFORM_CONNECTION_TILE_KEY}
      icon={<SwapIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.platform.title")}
      description={t("instellingen.tile.platform.desc")}
      items={[t("instellingen.item.platformKoppeling")]}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("platform-koppeling")}
    />
  );
}
